"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSharingLink = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _useGetCatalogueSharingLink = require("./useGetCatalogueSharingLink");
var _useGetPdpDynamicLink = require("./useGetPdpDynamicLink");
/**
 * Hook for getting sharing url
 */
const useGetSharingLink = () => {
  const [sharingLink, setSharingLink] = (0, _react.useState)('');
  const [currentStore, setCurrentStore] = (0, _react.useState)();
  const {
    favoriteListId,
    open,
    productCode
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    dynamicLink: pdpLink,
    loading: pdpLoading
  } = (0, _useGetPdpDynamicLink.useGetPdpDynamicLink)({
    currentStore
  });
  const {
    dynamicLink: catalogueLink,
    loading: catalogueLoading
  } = (0, _useGetCatalogueSharingLink.useGetCatalogueSharingLink)({
    currentStore
  });
  const dynamicLink = pdpLink ?? catalogueLink ?? undefined;
  const loading = pdpLoading || catalogueLoading;
  (0, _react.useEffect)(() => {
    const actualUrl = new URL(window.location.href);
    actualUrl.searchParams.delete(_constants.SHARE_OPEN_PARAM);
    const store = _jsCookie.default.get(_constants.COOKIE_NAME);
    setCurrentStore(store);
    if (productCode) {
      actualUrl.pathname = '/products/product';
      actualUrl.searchParams.set('code', productCode);
    }
    if (favoriteListId) {
      actualUrl.pathname = `/shared-list/${favoriteListId}`;
    }
    if (store && !actualUrl.searchParams.get(_constants.STORE_PARAM)) {
      actualUrl.searchParams.set(_constants.STORE_PARAM, store);
    }
    if (open) {
      setSharingLink(actualUrl.toString());
    }
  }, [favoriteListId, open, productCode]);
  return {
    loading,
    sharingLink: dynamicLink ?? sharingLink
  };
};
exports.useGetSharingLink = useGetSharingLink;
